import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { createComponentVNode, normalizeProps } from "inferno";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { createElement } from 'inferno-create-element';
import { animateOnAdd, animateOnRemove } from './animatedComponent';

function OriginalAnimated(_ref) {
  var el = _ref.el,
      tag = _ref.tag,
      children = _ref.children,
      attrs = _objectWithoutProperties(_ref, ["el", "tag", "children"]);

  return createElement(tag || el || 'div', attrs, children);
}

function Animated(_ref2) {
  var prefix = _ref2.prefix,
      onDidEnter = _ref2.onDidEnter,
      onDidLeave = _ref2.onDidLeave,
      attrs = _objectWithoutProperties(_ref2, ["prefix", "onDidEnter", "onDidLeave"]);

  return normalizeProps(createComponentVNode(2, OriginalAnimated, _objectSpread({}, attrs), null, {
    "onComponentDidMount": function onComponentDidMount(dom) {
      return animateOnAdd(dom, prefix, onDidEnter);
    },
    "onComponentWillUnmount": function onComponentWillUnmount(dom) {
      return animateOnRemove(dom, prefix, onDidLeave);
    }
  }));
}

export default Animated;
/*

// Why did this not work?

'use strict'
import { Component } from 'inferno'
import { createElement } from 'inferno-create-element'
import { animateOnAdd, animateOnRemove } from './animatedComponent'

function Animated ({ el, tag, prefix, onDidEnter, onDidLeave, children, ...attrs}) {

  attrs.onComponentDidMount = (dom) => animateOnAdd(dom, prefix, onDidEnter)
  attrs.onComponentWillUnmount = (dom) => animateOnRemove(dom, prefix, onDidLeave)

  return createElement(
    tag || el || 'div', 
    attrs, 
    children
  )
}

export default Animated

*/